import * as styles from './AdminOverrideBadge.css'

interface AdminOverrideBadgeProps {
  /** Approver display name, when known. */
  approverName?: string | null
  /** ISO timestamp of the override, when known. */
  overrideAt?: string | null
  /** Compact mode: badge only (for dense tables). */
  compact?: boolean
}

function formatTimestamp(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/**
 * Indicates a timesheet was approved via admin override. Render only when
 * `is_admin_override` is true; normal manager approvals show the approver
 * name without this badge.
 */
export function AdminOverrideBadge({ approverName, overrideAt, compact }: AdminOverrideBadgeProps) {
  const who = approverName ? `by ${approverName}` : ''
  const when = overrideAt ? ` on ${formatTimestamp(overrideAt)}` : ''
  const title = `Approved via admin override${who ? ` ${who}` : ''}${when}`.trim()

  return (
    <span className={styles.badge} title={title}>
      Admin override
      {!compact && approverName && (
        <span className={styles.detail}>
          {approverName}
          {overrideAt && ` · ${formatTimestamp(overrideAt)}`}
        </span>
      )}
    </span>
  )
}
